import config from '@/config'
export  default [
  {
    title: "媒体组件",
    modules: [
      {
        icon: "FundOutlined",
        name: "轮播图",
        type:'banner',
        defaultData:{
          type:'banner',
          name:'图片轮播',
          data:[
            {imgUrl:'',linkType:'',linkUrl:""},
          ],
          params:{
            interval: "2800",
          },
          style:{
            paddingTB:8,
            paddingLR:8,
          }
        }
      },
      {
        icon: "WindowsOutlined",
        name: "图片橱窗",
        type:'windows',
        defaultData:{
          type:'windows',
          name:'图片橱窗',
          data:[
            {imgUrl:"",linkType:'',linkUrl:""},
          ],
          params:{
            interval: "2800"
          },
          style:{
            class:'full',
            paddingTB:8,
            paddingLR:8,
          }
        }
      },
    ],
  },
  {
    title: "商城组件",
    modules: [
      {
        icon: "SearchOutlined",
        name: "搜索框",
        type:'search',
        defaultData:{
          type:'search',
          name:'搜索框',
          params:{
            placeholder:'搜索商品'
          },
          style:{
            paddingTB:8,
            paddingLR:8,
            position:'static',
            themeColor:'#F85F24'
          }
        } 
      },
      {
        icon: "NotificationOutlined",
        name: "公告组",
        type:'notice',
        defaultData:{
          type:'notice',
          name:'公告组',
          params:{
            content:'这是一条自定义内容',
          },
          style:{
            backgroundColor:'#ffffff',
            textColor:'#000000',
            iconColor:'#F85F24',
            paddingTB:8,
            paddingLR:8,
          }
        } 
      },
      {
        icon: "AppstoreOutlined",
        name: "导航",
        type:'nav',
        defaultData:{
          type:'nav',
          name:'导航',
          data:[
            {imgUrl:'',linkUrl:"",name:'个人中心'},
            {imgUrl:'',linkUrl:"",name:'好物榜'},
            {imgUrl:'',linkUrl:"",name:'限时秒杀'},
            {imgUrl:'',linkUrl:"",name:'新品上架'},
          ],
          params:{
            interval: "2800"
          },
          style:{
            btnColor: "#ffffff",
            btnShape: "round"
          }
        }
      },
      {
        icon: "GiftOutlined",
        name: "礼品推荐",
        type:'guessLove',
        defaultData:{
          type:'guessLove',
          name:'礼品推荐',
          data:[],
          params:{
            rules:1,
            goodTitle:'热门兑换',
            show:true
          },
          style:{
            paddingTB:8,
            paddingLR:8,
            class:'full',
          }
        }
      },
      {
        icon: "HourglassOutlined",
        name: "限时兑换",
        type:'goods',
        defaultData:{
          type:'goods',
          name:'限时兑换',
          data:[],
          params:{
            goodTitle:'限时兑换',
            show:true,
          },
          style:{
            paddingTB:8,
            paddingLR:8,
          }
        }
      },
    ],
  }
]